import React from 'react';
import PropTypes from 'prop-types';
import { CDialog, Notice, NOTICE_TYPES } from '@appcues/component-library';

const AcceptTransferModal = ({ accountId, onClose, onSubmit }) => {
  const handleSubmit = () => onSubmit({ accountId });
  return (
    <CDialog
      title="Accept transfer to account"
      secondaryActionText="Cancel"
      onSecondaryAction={onClose}
      primaryActionText="Yes, transfer"
      onPrimaryAction={handleSubmit}
    >
      <p>
        You will be transferred into Account {accountId}. You will lose access
        to flows created in this account.
      </p>
      <p>Are you sure you want to continue?</p>
      <Notice status={NOTICE_TYPES.warning}>
        <b>Warning:</b> You will no longer be able to access flows, themes, or
        data created on your current account.
      </Notice>
    </CDialog>
  );
};

AcceptTransferModal.propTypes = {
  accountId: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AcceptTransferModal;
